import { ref } from 'vue'

const defaultBreakpoints = {
    phone: 520,
    tablet: 960,
    notebook: 1240,
    desktop: 1600,
}

const phone = ref(true)
const tablet = ref(false)
const notebook = ref(false)
const desktop = ref(false)
const display = ref(false)

let initialized = false

const update = () => {
    phone.value = window.matchMedia(`(max-width: ${defaultBreakpoints.phone}px)`).matches
    tablet.value = window.matchMedia(`(max-width: ${defaultBreakpoints.tablet}px)`).matches
    notebook.value = window.matchMedia(`(max-width: ${defaultBreakpoints.notebook}px)`).matches
    desktop.value = window.matchMedia(`(max-width: ${defaultBreakpoints.desktop}px)`).matches
    display.value = window.matchMedia(`(min-width: ${defaultBreakpoints.desktop}px)`).matches
}

export const useBreakpoints = () => {
    if (typeof window !== 'undefined' && !initialized) {
        update()
        window.addEventListener('resize', update)
        window.addEventListener('orientationchange', update)
        window.addEventListener('load', update)
        initialized = true
    }

    return { phone, tablet, notebook, desktop, display }
}
